import { useEffect, useState } from "react";
import { getPricing } from "@/lib/s2tApi";
import { Check } from "lucide-react";

export const PricingCards = () => {
  const [pricing, setPricing] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    getPricing()
      .then(setPricing)
      .catch(() => setErr(true));
  }, []);

  if (err || !pricing) {
    return (
      <p data-testid="pricing-status" className="text-center text-sm text-[#5A6757]">
        {err ? "Pricing is loading from Source2Table…" : "Loading pricing…"}
      </p>
    );
  }

  const tiers = [
    { key: "standard", name: "Standard", highlight: false, data: pricing.standard },
    { key: "premium", name: "Premium", highlight: true, data: pricing.premium },
  ];

  return (
    <div className="grid sm:grid-cols-2 gap-6" data-testid="pricing-cards">
      {tiers.map((t) => (
        <div
          key={t.key}
          data-testid={`pricing-card-${t.key}`}
          className={`rounded-3xl p-7 border shadow-sm ${
            t.highlight
              ? "bg-[#4A6B41] text-[#F9F6F0] border-[#4A6B41]"
              : "bg-white text-[#1C241B] border-[#D8E0D5]"
          }`}
        >
          <div className="flex items-center justify-between">
            <h4 className="font-sans font-extrabold text-xl">{t.name}</h4>
            {t.highlight && (
              <span className="rounded-full bg-[#C86D51] text-[#F9F6F0] text-xs font-bold px-3 py-1 uppercase tracking-wider">
                Most popular
              </span>
            )}
          </div>
          <div className="mt-4 flex items-baseline gap-1">
            <span className="font-sans font-extrabold text-4xl">
              ${t.data.monthly}
            </span>
            <span className={t.highlight ? "text-[#F9F6F0]/80" : "text-[#5A6757]"}>
              /mo
            </span>
          </div>
          <p className={`mt-1 text-sm ${t.highlight ? "text-[#F9F6F0]/80" : "text-[#5A6757]"}`}>
            or ${t.data.annual}/year
          </p>
          <ul className="mt-5 space-y-2.5">
            {t.data.features.map((f) => (
              <li key={f} className="flex items-start gap-2 text-sm">
                <Check
                  size={18}
                  className={`mt-0.5 shrink-0 ${t.highlight ? "text-[#F9F6F0]" : "text-[#4A6B41]"}`}
                />
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
